import { useState } from 'react';
import { BottomSheet } from './BottomSheet';
import { InputField } from './InputField';
import { FormFooter } from './FormFooter';

interface EditNameModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (value: string) => void;
  currentValue: string;
  field: 'firstName' | 'lastName';
}

export const EditNameModal = ({
  isOpen,
  onClose,
  onSave,
  currentValue,
  field
}: EditNameModalProps) => {
  const [value, setValue] = useState(currentValue);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = async () => {
    // Validación
    if (!value.trim()) {
      setError('Este campo es obligatorio');
      return;
    }

    setError('');
    setIsLoading(true);

    // Simular guardado
    setTimeout(() => {
      onSave(value);
      setIsLoading(false);
      onClose();
    }, 800);
  };

  const handleClose = () => {
    setValue(currentValue);
    setError('');
    onClose();
  };

  const config = {
    firstName: {
      title: 'Editar Nombre(s)',
      label: 'Nombre(s)',
      placeholder: 'Ingresa tu(s) nombre(s)',
      helperText: 'Como aparece en tu identificación oficial'
    },
    lastName: {
      title: 'Editar Apellido paterno',
      label: 'Apellido paterno',
      placeholder: 'Ingresa tu apellido paterno',
      helperText: 'Como aparece en tu identificación oficial'
    }
  };

  const fieldConfig = config[field];

  return (
    <BottomSheet isOpen={isOpen} onClose={handleClose} title={fieldConfig.title}>
      <div className="space-y-6">
        <InputField
          label={fieldConfig.label}
          value={value}
          onChange={(val) => {
            setValue(val);
            setError('');
          }}
          placeholder={fieldConfig.placeholder}
          error={error}
          helperText={!error ? fieldConfig.helperText : undefined}
          disabled={isLoading}
        />

        <FormFooter
          onCancel={handleClose}
          onSave={handleSave}
          isLoading={isLoading}
          disabled={!value.trim()}
          variant="stacked"
        />
      </div>
    </BottomSheet>
  );
};
